export default function App() {
  return (
    <section id="app" className="relative py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[900px] mx-auto">
        <div className="bg-background-200/60 rounded-2xl border border-background-300/30 p-8 md:p-10">
          <div className="flex flex-col lg:flex-row items-center gap-8">
            <div className="flex-1 text-center lg:text-left">
              <span className="inline-block px-3 py-1 text-xs font-medium text-primary-400 bg-primary-500/10 rounded-full mb-4">
                APP下载
              </span>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-3">
                随时随地，高清观影
              </h2>
              <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
                下载桃子影院移动客户端，享受离线缓存、画质记忆、个性化推荐等专属功能。通勤路上、旅行途中，精彩影视永不间断。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <div className="w-full sm:w-auto px-8 py-3 bg-background-50 border border-background-300/30 rounded-xl flex items-center justify-center gap-3 cursor-pointer hover:border-primary-500/30 transition-colors">
                  <i className="ri-android-line text-xl text-primary-400"></i>
                  <div className="text-left">
                    <div className="text-xs text-foreground-500">Android 下载</div>
                    <div className="text-sm font-medium text-foreground-100">V3.5.2</div>
                  </div>
                </div>
                <div className="w-full sm:w-auto px-8 py-3 bg-background-50 border border-background-300/30 rounded-xl flex items-center justify-center gap-3 cursor-pointer hover:border-primary-500/30 transition-colors">
                  <i className="ri-apple-line text-xl text-primary-400"></i>
                  <div className="text-left">
                    <div className="text-xs text-foreground-500">iOS 下载</div>
                    <div className="text-sm font-medium text-foreground-100">V3.2.0</div>
                  </div>
                </div>
              </div>
              <div className="mt-4 flex items-center justify-center lg:justify-start gap-4 text-xs text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-download-2-line"></i> 500万+
                </span>
                <span>累计下载</span>
              </div>
            </div>
            <div className="flex-shrink-0">
              <div className="w-[180px] h-[320px] bg-background-50 rounded-2xl border border-background-300/30 overflow-hidden relative">
                <div className="absolute top-3 left-1/2 -translate-x-1/2 w-16 h-1 bg-background-400 rounded-full"></div>
                <div className="pt-8 px-4">
                  <div className="flex items-center gap-2 mb-4">
                    <div className="w-5 h-5 rounded bg-primary-500 flex items-center justify-center">
                      <i className="ri-movie-2-line text-background-950 text-xs"></i>
                    </div>
                    <span className="text-xs font-heading font-bold text-foreground-100">桃子影院</span>
                  </div>
                  <div className="space-y-2">
                    {[1, 2, 3, 4].map((i) => (
                      <div key={i} className="h-10 bg-background-200 rounded-lg"></div>
                    ))}
                  </div>
                  <div className="mt-4 space-y-2">
                    <div className="h-24 bg-background-200 rounded-lg"></div>
                    <div className="h-24 bg-background-200 rounded-lg"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}